import _slicedToArray from "/home/vsts/work/1/s/Office.Planner.Website/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/home/vsts/work/1/s/Office.Planner.Website/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .tooltip {\n    display: flex;\n    flex-direction: column;\n    background-color: #11142d;\n    color: ", ";\n    padding: 0.5rem;\n    border-radius: 0.5rem;\n    box-shadow: 0 0.3px 0.3px -4px rgba(0, 0, 0, 0.081), 0 1.1px 2px -4px rgba(0, 0, 0, 0.119),\n      0 5px 10px -4px rgba(0, 0, 0, 0.2);\n\n    transform: scale(0.8);\n    transform-origin: center;\n    opacity: 0;\n    transition: 0.2s cubic-bezier(0.45, 0, 0.21, 1);\n\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, useState, cloneElement } from 'react';
import { usePopper } from 'react-popper';
import styled from 'styled-components';
var StyledTooltip = styled.div(_templateObject(), function (props) {
  return props.theme.colors.labelInverted;
}, function (props) {
  return props.isOpen && "\n    transform: scale(1);\n    opacity: 1;\n  ";
});

function Tooltip(_a) {
  var children = _a.children,
      content = _a.content,
      _a$placement = _a.placement,
      placement = _a$placement === void 0 ? 'bottom' : _a$placement,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      rest = __rest(_a, ["children", "content", "placement", "className"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      referenceElement = _useState4[0],
      setReferenceElement = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      popperElement = _useState6[0],
      setPopperElement = _useState6[1];

  var _usePopper = usePopper(referenceElement, popperElement, {
    placement: placement,
    modifiers: [{
      name: 'offset',
      options: {
        offset: [0, 4]
      }
    }]
  }),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes;

  var renderTarget = function renderTarget() {
    var target = Children.only(children); // @ts-ignore

    return cloneElement(target, {
      ref: setReferenceElement,
      onMouseEnter: function onMouseEnter() {
        return window.innerWidth >= 1024 && setIsOpen(true);
      }
    });
  };

  return _jsxs(StyledTooltip, Object.assign({
    placement: placement,
    isOpen: isOpen,
    className: "tooltip-container ".concat(className)
  }, rest, {
    onMouseLeave: function onMouseLeave() {
      return setIsOpen(false);
    }
  }, {
    children: [renderTarget(), _jsx("div", Object.assign({
      ref: setPopperElement,
      style: Object.assign(Object.assign({}, styles.popper), {
        zIndex: 99,
        pointerEvents: 'none'
      })
    }, attributes.popper, {
      children: _jsx("div", Object.assign({
        className: "tooltip"
      }, {
        children: content
      }), void 0)
    }), void 0)]
  }), void 0);
}

export default Tooltip;